import { useState } from "react";

import Breadcrumbs from "../../../reusebale/breadcrumbs";
import PersonalForm from "../personal-information/personal-form";
import UploadImage from "../personal-information/upload-image";

import { useDispatch, useSelector } from "react-redux";

import * as AuthAction from "../../../../store/actions/auth/AuthAction";

import BaseUrl from "../../../../constants/BaseUrl";
import { ShowError, ShowSuccess } from "../../../../utils/ToasFunction";

const PersonalInfo = ({ onBack, clases }) => {
  const dispatch = useDispatch();
  const { loginSuccess, userCompleteProfile } = useSelector(
    (state) => state.auth
  );
  const [imageObj, setImageObj] = useState(null);
  const [loading, setLoading] = useState(false);

  const UploadImageToServerImage = (file) => {
    console.log("file", file);
    setLoading(true);
    const formdata = new FormData();
    formdata.append("image", file);

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(
      // `https://api.dev.theflexmanager.com/api/uploads/upload`,
      `${BaseUrl}api/uploads/cloudinary-upload`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.cloudinary?.secure_url) {
          setLoading(false);
          const profileImage = {
            url: result.cloudinary.secure_url,
            public_id: result.cloudinary.public_id,
            original_filename: result.cloudinary.original_filename,
          };
          setImageObj(profileImage);
          if (userCompleteProfile?.personalInformation?.profileImage) {
            handleDeleteCurrentImage();
            updateUserImage(profileImage);
          }
        } else {
          setLoading(false);
          ShowError(
            "Oops! Something went wrong. Please upload an image in JPEG or PNG format with a maximum size of 2MB"
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        ShowError(
          "Oops! Something went wrong. Please upload an image in JPEG or PNG format with a maximum size of 2MB"
        );
      });
  };

  const handleDeleteCurrentImage = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const raw = JSON.stringify({
      publicId:
        userCompleteProfile?.personalInformation?.profileImage?.public_id,
    });

    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      body: raw,
    };

    fetch(`${BaseUrl}api/uploads/cloudinary-delete`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.result === "ok") {
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        ShowError("Oops! Something went wrong");
      });
  };

  const updateUserImage = (imageObj) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      landloardId: loginSuccess?.user?._id,
      personalInformation: {
        firstName: userCompleteProfile?.personalInformation?.firstName,
        lastName: userCompleteProfile?.personalInformation?.lastName,
        landloardId: userCompleteProfile?.personalInformation?._id,
        email: userCompleteProfile?.personalInformation?.email,
        emailVerified: true,
        phoneNumber: Number(
          userCompleteProfile?.personalInformation?.phoneNumber
        ),
        phoneNumberVerified: true,
        profileImage: imageObj,
      },
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${BaseUrl}landlord/profile/createNewProfile`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status === "Success") {
          ShowSuccess("Profile image updated successfully");
          dispatch(
            AuthAction.GetLandlordProfile(
              loginSuccess?.user?._id,
              loginSuccess.token
            )
          );
        } else {
          ShowError("Failed to update profile image");
        }
      })
      .catch((error) => {
        ShowError("Failed to update profile image");
      });
  };

  return (
    <div className={`w-full ${clases}`}>
      <Breadcrumbs
        recordId={`${loginSuccess?.user?.firstName} ${loginSuccess?.user?.lastName}`}
        subheading="My Account"
        onBack={onBack}
      />
      <div className="flex justify-between mt-8">
        <div className="w-[64%]">
          <PersonalForm uploadedImageUrl={imageObj} onBack={onBack} />
        </div>
        <div className="w-[34%]">
          <UploadImage
            loading={loading}
            imageUploadFunction={(imagePath) => {
              UploadImageToServerImage(imagePath);
            }}
            imagePath={
              imageObj?.url
                ? imageObj.url
                : userCompleteProfile?.personalInformation?.profileImage?.url
            }
            imageTitle="Profile Image"
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
